import React, {Component, createRef} from 'react';
import uniqueId from 'lodash.uniqueid';
import axios from 'axios';
import * as settings from "../settings";
import SuggestionsItem from './SuggestionsItem/SuggestionsItem';

export default class Suggestions extends Component {
    constructor(props) {
        super(props);

        this.suggestionsRef = createRef();
        this.allLocations = this.props.locations;

        this.state = {
            data: null,
            message: settings.suggestionMessages.start,
        };

        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.getSuggestionData = this.getSuggestionData.bind(this);
        this.getActiveSuggestion = this.getActiveSuggestion.bind(this);
        this.updateScrollbar = this.updateScrollbar.bind(this);
    }

    componentDidMount() {
        // Add a custom scrollbar for suggestion list
        this.scrollbar = new PerfectScrollbar(
            this.suggestionsRef.current,
            settings.scrollbarOptions
        );

        if(this.props.query === "" && this.props.useEmptySearch) {
            this.getSuggestionData(this.props.query);
        }
    }

    componentDidUpdate(prevProps) {
        // updated query
        if(prevProps.query !== this.props.query) {
            if(this.props.type !== "map") {
                if(this.props.query || (this.props.query === "" && this.props.useEmptySearch)) {
                    clearTimeout(this.timeout);
                    this.timeout = setTimeout(() => {
                        this.getSuggestionData(this.props.query);
                    }, settings.delay);
                } else {
                    this.setState({
                        data: null,
                        message: settings.suggestionMessages.start
                    });
                }
            }
        }

        // updated locations - only for type of "map"
        if(prevProps.locations !== this.props.locations) {
            if(this.props.locations) {
                if(this.props.locations.length) {
                    this.setState({
                        data: this.props.locations
                    });
                } else {
                    this.setState({
                        data: null,
                        message: settings.suggestionMessages.noResults
                    });
                }
            } else {
                this.setState({
                    data: null,
                    message: settings.suggestionMessages.start
                });
            }
        }

        this.updateScrollbar();
    }

    handleKeyDown(event) {
        let newActiveElement = null;
        let currentlyActiveElement = document.activeElement;

        if(currentlyActiveElement.parentElement.parentElement ===
            this.suggestionsRef.current) {
            if(event.keyCode === 40) {
                // Arrow down
                newActiveElement = currentlyActiveElement.parentElement.nextElementSibling;
            } else if(event.keyCode === 38) {
                // Arrow up
                newActiveElement = currentlyActiveElement.parentElement.previousElementSibling;

                if(newActiveElement.nodeName !== "LI") {
                    newActiveElement = null;
                }
            }
        }

        if(newActiveElement) {
            newActiveElement.firstChild.focus();
        }
    }

    getSuggestionData(query) {
        axios.get(settings.apiUrls[this.props.type], {
            params: {
                query: query
            }
        })
        .catch(function (error) {
            if (error.response) {
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
            } else if (error.request) {
                console.log(error.request);
            } else {
                console.log('Error', error.message);
            }
            console.log(error.config);
        })
        .then(response => {
            if(response.data) {
                if(response.data.length) {
                    this.setState({
                        data: response.data,
                    });
                } else {
                    this.setState({
                        data: null,
                        message: settings.suggestionMessages.noResults,
                    });
                }

                this.updateScrollbar();
            }
        });
    }

    getActiveSuggestion() {
        let currentlyActiveElement = document.activeElement;

        if(currentlyActiveElement.parentElement.parentElement ===
            this.suggestionsRef.current) {
            return currentlyActiveElement;
        } else {
            return this.suggestionsRef.current.querySelector(".search-component__suggestions-item");
        }
    }

    updateScrollbar() {
        // Update scrollbar to get the right position
        this.scrollbar.update();
        this.suggestionsRef.current.scrollTop = 0;
    }

    render() {
        let suggestions;

        if(this.state.data) {
            suggestions = (
                this.state.data.map(item => {
                    item.id = uniqueId();
                    item.label = item.Description ? item.Description : item.Type;

                    return <SuggestionsItem key={item.id}
                                            content={item.Name}
                                            url={item.Url}
                                            searchableLabel={item.Country}
                                            nonSearchableLabel={item.label}
                                            pointId={item.Guid}
                                            query={this.props.query}
                                            matchInputToSuggestionPick={this.props.matchInputToSuggestionPick}
                                            handleSuggestionClick={this.props.handleSuggestionClick}/>
            }));
        } else {
            suggestions =  (
                <li className="search-component__suggestions-item">
                    <span>
                        {this.state.message}
                    </span>
                </li>
            );
        }


        return (
            <ul className="search-component__suggestions"
                ref={this.suggestionsRef}
                onKeyDown={this.handleKeyDown}>
                {suggestions}
            </ul>
        )
    }
}
